import { useSentryInit } from './useSentryInit.hook';
import { useContainerInit } from './useContainerInit.hook';
import { useI18NextInit } from './useI18nextInit.hook';
import { useMailboxReady } from './useMailboxReady.hook';

// Here we do everything we need to init app
export const useInitApp = () => {
  const { isI18NextInitialized } = useI18NextInit();
  const mailboxStatus = useMailboxReady();

  useSentryInit();
  useContainerInit();

  return { isI18NextInitialized, mailboxStatus };
};

export { initSentry } from './useSentryInit.hook';
export { initI18Next } from './useI18nextInit.hook';
